import { MINUTES_PER_HOUR } from "@shared-kernel/core/constants/time.constants";

/**
 * Convert a "HH:mm" time string to minutes since midnight ("09:30" -> 570)
 */
export const timeStringToMinutes = (timeString: string): number => {
  const [hours = 0, minutes = 0] = timeString.split(":").map(Number);
  return hours * MINUTES_PER_HOUR + minutes;
};

/**
 * Convert minutes since midnight to a "HH:mm" time string (570 -> "09:30")
 */
export const minutesToTimeString = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
  const minutes = totalMinutes % MINUTES_PER_HOUR;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};
